module.exports = __webpack_public_path__ + "static/media/bg-login.adecc249.webp";